/**
 * The FoldMyCard mark - a square folded corner to corner, in the two brand
 * colours - and the name beside it, for the top of every page (2026-10-17;
 * the same mark as in the video, video/studio.tsx).
 */
import { t } from './strings.ts';

export function LogoMark({ size = 26 }: { size?: number }) {
  return (
    <svg viewBox="0 0 32 32" width={size} height={size} aria-hidden="true" className="logo-mark">
      <path d="M4 4h24L4 28z" fill="#0f6f8c" /><path d="M28 4v24H4z" fill="#d9772b" />
    </svg>
  );
}

/** The mark and the name: on its own (the front page), or as the way back to it. */
export function Logo() {
  return <span className="logo"><LogoMark /><span>{t('appName')}</span></span>;
}
